// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1_PwY","content":"ManualTimeModal_content__slA5m"};